import React, { Component } from "react";
import { Link } from "react-router-dom";
import classnames from 'classnames';

export default class CustomLink extends Component {
    constructor() {
      super();
   
      this.onClick = this.onClick.bind(this);
    }
   
    onClick(e) {
      if (this.props.hasSubMenu) this.props.toggleSubMenu(e);
      else {
        this.props.activateMe({
          newLocation: this.props.to,
          selectedMenuLabel: this.props.label,
        });
      }
    }
   
    render() {
      return (
        <Link  className={classnames(
            this.props.className,
            this.props.active && this.props.classNameActive,
            this.props.hasActiveChild && this.props.classNameHasActiveChild,
          )} to={this.props.to} onClick={this.onClick}>
          {this.props.children}
        </Link>
      );
    }
  };